module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Books by Terri Blackstock")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Cape Refuge")]), _vm._v(" (Book 1 in series) ")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Emerald Windows")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Newpointe 911")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Private Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Shadow of Doubt")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Trial by Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Word of Honor")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Sun Coast Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Evidence of Mercy")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Justifiable Means")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Ulterior Motives")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Presumption of Guilt")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Second Chances")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Never Again Good-bye")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("When Dreams Cross")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v(" Blind Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Broken Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("With Beverly LaHaye")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Seasons Under Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v(" Showers in Season")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v(" Times and Seasons")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Season of Blessing")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Novellas")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Seaside")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e21ae23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003adpage.vue
// module id = 60
// module chunks = 0